/**
 * en-GB messages added by Phase 3 task L3 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const l3EnGB = {};
//# sourceMappingURL=l3.js.map